module.exports = __webpack_public_path__ + "static/xinchou-37b5b3f50e92d83665fa8eff26cc9f23.png";